import { StockDTO } from './StockDTO';
import { StockInnerCompanyDTO } from '../sub/company-stocks/company-stocks-inner.component';
import { FormControl, FormGroup } from '@angular/forms';


export interface CompanyComparableValuationExcelExportData {
  stocks: StockDTO[];
  currentCompany: StockInnerCompanyDTO;
}

export type DataAsOfFormGroup = FormGroup<{
  commonDataAsOf: FormControl<Date>;
}>;


export const fmpUrl = 'https://site.financialmodelingprep.com/financial-summary/';
